<template>
  <container>
    <div class="wrap">
      <div class="custom-input" :class="$platformClass">
        <label for>
          <span>*</span>
          {{ createWorkLetters._game }}
        </label>
        <a
          href="javascript:;"
          :class="placeholder.game ? false : 'default'"
          @click.prevent="callSelect('game_id')"
        >
          <i class="custom-input-icon"></i>
          {{ placeholder.game || createWorkLetters._gameHolder }}
        </a>
      </div>
      <div class="custom-input" :class="$platformClass">
        <label for>
          <span>*</span>
          {{ createWorkLetters._server }}
        </label>
        <a
          href="javascript:;"
          :class="placeholder.server ? false : 'default'"
          @click.prevent="callSelect('server_id')"
        >
          <i class="custom-input-icon"></i>
          {{ placeholder.server || createWorkLetters._serverHolder }}
        </a>
      </div>
      <div class="custom-input" :class="$platformClass">
        <label for>
          <span>*</span>
          {{ createWorkLetters._role }}
        </label>
        <input
          type="text"
          v-model="placeholder.role"
          :placeholder="
            letters.accountrecovery && letters.accountrecovery._roleHolder
          "
        />
      </div>
      <div class="submit" :class="$platformClass">
        <a href="javascript:;" class="submit-btn" @click="submitRecovery">
          {{ createWorkLetters._submit }}
          <i v-if="!$isOmni" class="submit-btn-check"></i>
        </a>
      </div>
      <div class="account-tips" :class="$platformClass">
        {{ letters.accountrecovery && letters.accountrecovery._tips }}
      </div>
    </div>
    <select-box
      :open="selectBox.showSelectBox"
      :list="selectBox.selectList"
      :title="selectBox.selectTile"
      :selectedIndex="selectBox.selectedIndex"
      @select="selectCallback"
      @close="closeSelect"
    ></select-box>
    <success-popup
      :open="successPopup.show"
      :msg="successPopup.msg"
      @toggle="toggleSuccess"
    ></success-popup>
  </container>
</template>

<script>
import {
  TOAST,
  CLOSE_TOAST,
  OPEN_IMAGE_PREVIEW
} from '../../store/support/event-type.js';

import container from '../../components/support/Container.vue';
import selectBox from '../../components/support/selectBox.vue';
import successPopup from '../../components/support/successPopup.vue';

import globalConfig from '../../utiles/globalConfig.js';

import { RECOVERY_ACCOUNT } from '@/resource/store/account';
import { mapMutations, mapActions } from 'vuex';

export default {
  name: 'accountRecovery',
  beforeCreate() {
    globalConfig.storeEntryParams();
  },
  created() {
    this.getGameList().then(({ res }) => {
      if (res.result === 1 && res.data.length > 0) {
        this.gameList = res.data;
        this.workParams.game_id = this.gameList[0].ID;
        this.placeholder.game = this.gameList[0].NAME;
        this.selectBox.selectedIndexs[0] = 0;
      }
    });
  },
  data() {
    return {
      canSelectGameInfo: 1,
      workParams: {
        category_id: undefined,
        game_id: undefined,
        game_server_id: undefined,
        character_name: undefined,
        message: undefined,
        pic: []
      }, // 用于提交的工单参数
      previewList: [], // 预览图片列表，base64格式
      selectBox: {
        showSelectBox: false,
        selectList: [],
        selectTile: '',
        variableName: '',
        selectedIndexs: [-1, -1, -1, -1],
        selectedIndex: -1
      }, // 通用选择框参数
      successPopup: {
        show: false,
        msg: ''
      }, // 提交成功的弹窗内容
      placeholder: {
        game: '',
        server: '',
        role: '',
        create: ''
      }, // 在通用弹窗选择的结果
      showLoading: false,
      gameList: [],
      serverList: [],
      roleList: [],
      createWorkLetters: {}
    };
  },
  computed: {
    letters() {
      return this.$store.state.support.letters;
    }
  },
  watch: {
    letters() {
      this.createWorkLetters = this.letters.creatework || {};
    }
  },
  methods: {
    ...mapActions(['getGameList', 'getServerList', 'getCharName', 'getCharNameDcqvn']),
    ...mapMutations([TOAST, CLOSE_TOAST, OPEN_IMAGE_PREVIEW]),
    validateParams(params) {
      let msgList = {
        gameId: this.createWorkLetters._gameHolder,
        serverId: this.createWorkLetters._serverHolder,
        roleName: this.letters.accountrecovery._roleHolder
      };
      return new Promise((resolve, reject) => {
        /* eslint-disable  no-unused-vars */
        for (let key in params) {
          if (!params[key]) {
            reject({ dirty: true, msg: msgList[key] });
            break;
          }
        }
        resolve({ dirty: false, msg: '' });
      });
    },
    submitRecovery() {
      let params = {
        gameId: this.workParams.game_id,
        serverId: this.workParams.game_server_id,
        roleName: this.placeholder.role,
        language: this.$store.state.support.language
      };
      this.validateParams(params)
        .then(res => {
          return this.$store.dispatch(RECOVERY_ACCOUNT, params).then(res => {
            this[TOAST](res?.msg || res?.message);
          });
        })
        .catch(err => {
          this[TOAST](err?.msg || err?.message);
        });
    },
    /**
     * 调起通用选择框，根据传入参数分别选择游戏、服务器、角色
     * @param {string} type
     */
    callSelect: (function () {
      let objectArrToStringArr = function (arr, prop) {
        let result = [];
        arr.forEach(val => {
          result.push(val[prop]);
        });
        return result;
      };
      let strategy = {
        game_id: function () {
          this.getGameList().then(({ res }) => {
            if (res.result === 1) {
              this.gameList = res.data;
              this.selectBox.selectList = objectArrToStringArr(
                this.gameList,
                'NAME'
              );
              this.selectBox.showSelectBox = true;
              this.selectBox.variableName = 'game_id';
              this.selectBox.selectedIndex = this.selectBox.selectedIndexs[0];
            }
          });
          this.selectBox.selectTile = this.createWorkLetters._game;
        },
        server_id: function () {
          let game_id = this.workParams.game_id;
          if (!game_id) {
            this[TOAST](this.createWorkLetters._gameHolder);
            return;
          }
          this.getServerList(game_id).then(({ res }) => {
            if (res.result === 1) {
              this.serverList = res.data;
              this.selectBox.variableName = 'server_id';
              if (!this.serverList.length) {
                this[TOAST](this.createWorkLetters._noServer);
                return;
              } else {
                this.selectBox.selectList = objectArrToStringArr(
                  this.serverList,
                  'REAL_NAME'
                );
              }
              this.selectBox.showSelectBox = true;
              this.selectBox.selectedIndex = this.selectBox.selectedIndexs[1];
            } else {
              this[TOAST](res?.msg);
            }
          });
          this.selectBox.selectList = this.gameList;
          this.selectBox.selectTile = this.createWorkLetters._server;
        },
        create: function () {
          this.selectBox.selectList =
            this.createWorkLetters._selectBox.selectList;
          this.selectBox.selectTile =
            this.createWorkLetters._selectBox.selectTile;
          this.selectBox.showSelectBox = true;
          this.selectBox.variableName = 'create';
          this.selectBox.selectedIndex = this.selectBox.selectedIndexs[3];
        }
      };
      return function (type) {
        strategy[type].call(this);
      };
    })(),
    closeSelect: function () {
      this.selectBox.showSelectBox = false;
    },
    toggleSuccess: function () {
      this.successPopup.show = !this.successPopup.show;
    },
    /**
     * 关闭通用选择框之后的回调，写入对应的选择结果
     * @param {string} type
     */
    selectCallback: (function () {
      let strategy = {
        game_id: function (index) {
          this.workParams.game_id = this.gameList[index].ID;
          this.placeholder.game = this.gameList[index].NAME;
          this.workParams.server_id = '';
          this.placeholder.server = '';
          this.workParams.role_id = '';
          this.placeholder.role = '';
          this.selectBox.selectedIndexs[0] = index;
          this.selectBox.selectedIndexs[1] = -1;
          this.selectBox.selectedIndexs[2] = -1;
        },
        server_id: function (index) {
          this.workParams.game_server_id = this.serverList[index].SID;
          this.placeholder.server = this.serverList[index].REAL_NAME;
          this.workParams.role_id = '';
          this.placeholder.role = '';
          this.selectBox.selectedIndexs[1] = index;
          this.selectBox.selectedIndexs[2] = -1;
          const getCharNameFn =
            this.workParams.game_id == 215 ? this.getCharNameDcqvn : this.getCharName;
          getCharNameFn({ server_id: this.workParams.game_server_id, game_id: this.workParams.game_id }).then(
            ({ res }) => {
              if (res?.result === 1) {
                if (res?.data?.length > 0) {
                  this.workParams.role_id = res?.data[0]?.roleID;
                  this.placeholder.role = res?.data[0]?.roleName;
                }
              }
              // else {
              //   this[TOAST](res?.msg ? res?.msg : res?.data?.msg);
              // }
            }
          );
        },
        create: function (index) {
          this.workParams.category_id = index + 1;
          this.placeholder.create =
            this.createWorkLetters._selectBox.selectList[index];
          this.selectBox.selectedIndexs[3] = index;
        }
      };
      return function (index) {
        let variableName = this.selectBox.variableName;
        strategy[variableName].call(this, index);
      };
    })()
  },
  components: {
    container,
    selectBox,
    successPopup
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/support.scss';
@import '../../assets/scss/platform-support.scss';
.loading {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
  background: rgba(0, 0, 0, 0.5);
  &-icon {
    @include size(50, 50);
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    @include bgPng('loading');
    display: inline-block;
    animation: circle linear 1s infinite;
  }
}
.custom-input {
  width: 100%;
  margin-top: 30px;
  label {
    height: 42px;
    width: 100%;
    display: block;
    color: #414141;
    font-size: 24px;
    font-weight: bold;
    line-height: 42px;
    padding-left: 12px;
    span {
      color: #de6262;
      font-size: 24px;
    }
  }
  &-icon {
    float: right;
    margin-top: 36px;
    @include size(14, 8);
    display: inline-block;
    @include bgPng('triangle-down');
    vertical-align: text-bottom;
  }
  input,
  a,
  textarea {
    width: 100%;
    height: 80px;
    display: block;
    line-height: 80px;
    padding: 0 32px;
    border: solid 1px #dfdfdf;
    color: #cacaca;
    font-size: 24px;
  }
  textarea {
    height: 280px;
  }
}

.account-tips {
  font-size: 30px;
  color: #ff7777;
  margin-top: 30px;
  line-height: 30px;
  text-align: center;
}

/*覆盖插件样式*/
.submit {
  width: 100%;
  padding: 0 30px;
  margin-top: 30px;
  // position: fixed;
  // bottom: 30px;
  // left: 0;
  // z-index: 9;
  &-btn {
    width: 100%;
    height: 80px;
    line-height: 80px;
    display: block;
    @include bgC(#5fd193);
    color: #fff;
    font-size: 30px;
    text-align: center;
    &-check {
      @include size(26, 19);
      display: inline-block;
      @include bgPng('tiny-check-icon');
    }
  }
}
.wrap {
  height: 100%;
  overflow-y: auto;
  padding-bottom: 30px;
}

:deep(.common-header-back) {
  display: none;
}
</style>
